import { render, staticRenderFns } from "./RetornoAtendimento.vue?vue&type=template&id=f4e9620c&"
import script from "./RetornoAtendimento.vue?vue&type=script&lang=js&"
export * from "./RetornoAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports